<!-- añadir siempre este div para englobar form -->
<div class="form-container__newCliente" *ngIf="contratista?.firstTime == false">
    <mat-horizontal-stepper
      [linear]="isLinear"
      #stepper
      [@.disabled]="true"
      class="stepsForm"
    >
      <mat-step [stepControl]="firstPage">
        <h2 class="warning2">Por favor, complete su Perfil de Contratista antes de continuar</h2>
        <h1 class="warning3">Perfil de Empresa</h1>
        <form novalidate [formGroup]="firstPage" class="form__perfilCliente">
          <h2>Datos de la empresa</h2>
          <div class="datos__empresa">
            <mat-form-field appearance="outline">
              <mat-label for="razonSocial">Razón Social *</mat-label>
              <input
                matInput
                type="text"
                formControlName="razonSocial"
                id="razonSocial"
              />
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label for="nombreComercial">Nombre Comercial *</mat-label>
  
              <input
                matInput
                type="text"
                formControlName="nombreComercial"
                id="nombreComercial"
              />
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label for="cif">CIF *</mat-label>
              <input matInput type="text" formControlName="cif" id="cif" />
              <mat-error>Por favor introduzca un número de CIF válido</mat-error>
            </mat-form-field>
          </div>
  
          <h2>Domicilio Fiscal</h2>
  
          <div class="displayFlex datos__fiscal">
            <mat-form-field appearance="outline" class="via">
              <mat-select placeholder="Tipo de Vía *" formControlName="via">
                <div *ngFor="let tipo of tiposVia">
                  <mat-option value="{{ tipo }}">{{ tipo }}</mat-option>
                </div>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="nombre">
              <mat-label for="nombreVia">Nombre de la Vía *</mat-label>
              <input
                matInput
                type="text"
                formControlName="nombreVia"
                id="nombreVia"
              />
            </mat-form-field>
            <div class="direccion">
            <mat-form-field appearance="outline" class="numero">
              <mat-label for="numeroVia">Nº *</mat-label>
              <input
                matInput
                type="text"
                formControlName="numeroVia"
                id="numeroVia"
              />
            </mat-form-field>
            <mat-form-field appearance="outline" class="planta">
              <mat-label for="planta">Planta</mat-label>
              <input matInput type="text" formControlName="planta" id="planta" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="letra">
              <mat-label for="letra">Letra</mat-label>
              <input matInput type="text" formControlName="letra" id="letra" />
            </mat-form-field>
          </div>
          </div>
          <div class="datos__fiscal2">
            <mat-form-field appearance="outline">
            <mat-label>Comunidad Autonoma</mat-label>
              <mat-select formControlName="ccaa">
                <mat-option *ngFor="let autonomia of autonomias" [value]="autonomia" #matOption (click)="selectAutonomia(matOption)">
                  {{autonomia}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <mat-form-field appearance="outline" *ngIf="provincias">
              <mat-label>Provincia</mat-label>
              <mat-select formControlName="provincia">
                <mat-option *ngFor="let provincia of provincias" [value]="provincia" #matOption (click)="selectProvincia(matOption)">
                  {{provincia.NOMBRE}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-form-field appearance="outline" *ngIf="municipios">
              <mat-label>Localidad</mat-label>
              <mat-select formControlName="localidad">
                <mat-option *ngFor="let municipio of municipios" [value]="municipio" #matOption (click)="selectMunicipio(matOption)">
                  {{municipio.NOMBRE}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp">
              <mat-label for="codigoPostal">Código Postal *</mat-label>
              <input
                matInput
                type="text"
                formControlName="codigoPostal"
                id="codigoPostal"
              />
            </mat-form-field>
          </div>
          <div class="motivo">
            <div>
            <h2>Actividad de la empresa</h2>
            <mat-form-field appearance="outline" class="motivo-input">
              <mat-label for="actividadEmpresa">
                Actividad de la empresa *
              </mat-label>
              <input
                matInput
                type="text"
                formControlName="actividadEmpresa"
                id="actividadEmpresa"
              />
            </mat-form-field>
          </div>
          </div>
          <p>* Campos Obligatorios</p>
          <div class="boton__siguiente">
            <button
              matStepperNext
              (click)="setContratista()"
              [disabled]="firstPage.invalid"
            >
              Siguiente
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondPage">
        <div *ngIf="contactsFirstStep">
          <h1 class="warning3">Perfil de Empresa</h1>
          <form novalidate [formGroup]="secondPage" class="form__perfilCliente">
            <h2>Datos del Responsable</h2>
            <mat-hint>Todas las notificaciones por correo electrónico (ej: solicitud de nueva documentación, denegación o vencimiento de documentación, vencimiento de licencias, etc.) llegarán al Mail de Contacto</mat-hint>
            <div class="displayFlex datos__responsable">
              <mat-form-field appearance="outline" class="responsable-nombre">
                <mat-label for="nombreContacto">
                  Nombre y apellidos del Contacto *
                </mat-label>
  
                <input
                  matInput
                  type="text"
                  formControlName="nombreContacto"
                  id="nombreContacto"
                />
              </mat-form-field>
  
              <mat-form-field appearance="outline" class="responsable-nombre">
                <mat-label for="nmailContacto">
                  Mail de contacto *
                </mat-label>
                <input
                  matInput
                  type="email"
                  formControlName="mailContacto"
                  id="mailContacto"
                />
              </mat-form-field>
            </div>
            <p>* Campos Obligatorios</p>
            <!-- <button class="boton__modificar">Modificar datos</button> -->
            <!-- <div class="datos__añadir">
              <span>
                Puedes añadir hasta 4 Contactos adicionales a tu empresa
              </span>
              <button (click)="handleAddContactos($event)" class="boton__añadir">
                Añadir Contactos
              </button>
            </div> -->
            
            <div class="boton__pasos">
              <button matStepperPrevious>Anterior</button>
              <button
                matStepperNext
                (click)="updateContratistaById()"
                [disabled]="secondPage.invalid"
               
              >
                Siguiente
              </button>
            </div>
            </form>
            </div>
          </mat-step>
            <mat-step [stepControl]="thirdPage">
              <div >
                <h1 class="warning3">Pago de Licencias</h1>
                <ng-container *ngIf="contratista?.xtensaBasica == true">
                  <form novalidate [formGroup]="thirdPage" class="form__perfilCliente">
                    <h2>Su Cliente ha indicado el siguiente número de Centros Productores: <span class="precio">{{contratista.numeroInvitacion}}</span></h2>
                    <div class="infoPago">
                      <p>Para poder disfrutar del uso de Xtensa deberá hacer el pago de las <span class="precio">{{contratista.numeroInvitacion}}</span> Licencias requeridas por su Cliente.</p>
                      <p>El precio de cada Licencia anual es de <span class="precio">{{precioBasicaIvaShow}}€ </span> por centro productor (IVA incluido).</p>
                      <p class="totalResults2">El Importe Total a pagar es de <span class="totalResults__number">XXXX</span> (IVA incluido)</p>
                    </div>
                    <h3>Seleccione el método de pago:</h3>
                  <div class="metodoPago">
                    <div class="radioButton">
                      <div class="metodo-check">
                        <img src="./../../../../assets/tarjeta-de-credito.png" alt="">
                        <input
                          type="radio"
                          value="tarjeta"
                          id="tarjeta"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                          [checked]="true"
                        />
                        <label for="tarjeta"> Tarjeta de Crédito</label>
                      </div>
                     <!--  <div class="metodo-check">
                       <img src="./../../../../assets/transferencia.png" alt="">
                        <input
                          type="radio"
                          value="transferencia"
                          id="transferencia"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                        />
                        <label for="transferencia"> Transferencia Bancaria</label>
                      </div> -->
                    </div>
                  </div>
                    <div class="privacidad">
                      <input type="checkbox" id="privacidad" formControlName="policy" (change)="setPolicy($event)"/>
                     <label for="privacidad" id="privacidad"> He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a> y las <a href="https://xtensa.es/condiciones-de-compra/"  target="_blank">Condiciones de Compra</a></label><br><br>
                     <input type="checkbox" id="newsletter" (change)="setNewsletter($event)"/>
                     <label for="newsletter" id="newsletter" > Acepto recibir la información comercial que INPRONET SOLUTIONS SL <br> considere oportuno enviarme por correo electrónico. (Es posible darse de baja en cualquier momento)</label><br><br>
                     <p id="proteccion">
                      El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros. Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
                    </div>
                    <div class="boton__pasos">
                      <button matStepperPrevious>Anterior</button>
                      
                    </div>
                </form>
                <div class="div-tpv" *ngIf="button">
                <button class="btn-tpv" #buttonContainer></button>
              </div>
                 
                
                </ng-container>

                <ng-container *ngIf="contratista?.xtensaBasica != true">

                <form novalidate [formGroup]="thirdPage" class="form__perfilCliente">
                  <h2>Indique el número Centros de su titularidad que dan cobertura a las instalaciones de su Cliente, donde se almacenan los residuos que produce su actividad en dichas instalaciones:</h2>
                  <div class="displayFlex datos__responsable">
                    <mat-form-field appearance="outline" class="responsable-nombre">
                      <mat-label for="numeroLicencias">
                        Número de Licencias
                      </mat-label>
        
                      <input
                        matInput
                        type="number"
                        min="0"
                        value="0"
                        formControlName="numeroLicencias"
                        id="numeroLicencias"
                        (change)="selectPrecio()" 
                      />
                    </mat-form-field>
                  </div>
                  <div class="infoPago">
                    <p>Para poder disfrutar del uso de Xtensa deberá hacer el pago de las <span class="precio">{{thirdPage.value.numeroLicencias}}</span> Licencias indicadas.</p>
                    <p>El precio de cada Licencia anual es de <span class="precio">{{precioAmpliadaIvaShow}}€ </span> por centro productor (IVA incluido).</p>
                    <p class="totalResults2">El Importe Total a pagar es de <span class="totalResults__number">XXXX</span> (IVA incluido)</p>
                  </div>
                  <h2>Seleccione el método de pago:</h2>
                  <div class="metodoPago">
                    <div class="radioButton">
                      <div class="metodo-check">
                        <img src="./../../../../assets/tarjeta-de-credito.png" alt="">
                        <input
                          type="radio"
                          name="tipoPago"
                          value="tarjeta"
                          id="tarjeta"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                        />
                        <label for="tarjeta"> Tarjeta de Crédito</label>
                      </div>
                      <!-- <div class="metodo-check">
                        <img src="./../../../../assets/transferencia.png" alt="">
                        <input
                          type="radio"
                          name="tipoPago"
                          value="transferencia"
                          id="transferencia"
                          formControlName="pago"
                          (change)="setTipoPago($event)"
                          
                        />
                        <label for="transferencia"> Transferencia Bancaria</label>
                      </div> -->
                    </div>
                  </div>
                  <div class="privacidad">
                    <input type="checkbox" id="privacidad" formControlName="policy" (change)="setPolicy($event)"/>
                   <label for="privacidad" id="privacidad"> He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a> y las <a href="https://xtensa.es/condiciones-de-compra/"  target="_blank">Condiciones de Compra</a></label><br><br>
                   <input type="checkbox" id="newsletter" (change)="setNewsletter($event)"/>
                   <label for="newsletter" id="newsletter" > Acepto recibir la información comercial que INPRONET SOLUTIONS SL <br> considere oportuno enviarme por correo electrónico. (Es posible darse de baja en cualquier momento)</label><br><br>
                   <p id="proteccion">
                    El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros. Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
                  </div>
                  <div class="boton__pasos">
                    <button matStepperPrevious>Anterior</button>
                   </div> 
          </form>
          <div class="div-tpv" *ngIf="button">
            <button class="btn-tpv" #buttonContainer></button>
          </div>
        </ng-container>
        </div>
  
      </mat-step>
    </mat-horizontal-stepper>
  </div>
  
